import img_1 from '../image/Certificates/img_1.jpg'
import img_2 from '../image/Certificates/img_3.jpg'
import img_3 from '../image/Certificates/img_4.jpg'
import img_4 from '../image/Certificates/img_5.jpg'
import img_5 from '../image/Certificates/img_2.jpg'

export const phone = '+79037551472'

export const arrPortfolio = [ {image: img_1, title: 'Диплом'}, {image: img_2, title: 'Диплом'}, {image: img_3, title: 'генератор'}, {image: img_4, title: 'Диплом'},];

export const arrPortfolioModal = [ {image: img_1, title: 'Диплом'}, {image: img_2, title: 'Диплом'}, {image: img_3, title: 'генератор'}, {image: img_4, title: 'Диплом'}, {image: img_5, title: 'Диплом'},];